module.exports = __webpack_public_path__ + "img/seven.d17e3f40.png";